import { render } from "./App.vue?vue&type=template&id=c089ebda"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c089ebda&lang=less"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_59e517ed8ea5909a7bfb8c19836a23be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__